export default {
  "content": "<path d=\"M1 11l5-5-5-5\" stroke=\"#ff00cb\" stroke-width=\"2\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "width": "7",
    "height": "12",
    "viewBox": "0 0 7 12",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};